import { Clickable } from '@carvana/merch-components';
import { useContext } from 'react';
import { PickupAndDeliveryState } from '~/components/vdp/PickupAndDelivery';
import { useUserLocation } from '~/context/common/UserContext';
import ModalContext from '~/context/vdp/ModalContext';
import { DeliveryPickup } from '~/contracts/common';
import getAsSoonAsText from '~/utilities/date/getAsSoonAsText';
import { GridContainer, Header, Link, Text } from './Availability.styles';
import getIconToUse from './getIconToUse';

type OwnProps = {
  delivery?: Partial<DeliveryPickup>;
  componentState: PickupAndDeliveryState;
};

const DeliveryBox = ({ componentState, delivery = {} }: OwnProps) => {
  const {
    asSoonAsText = '',
    utcSoonestDateTimeIso,
    daysToAvailability
  } = delivery;
  const { city, state } = useUserLocation();
  const { setGeolocationModalOpen } = useContext(ModalContext);

  const deliveryDate = getAsSoonAsText(asSoonAsText, utcSoonestDateTimeIso);

  const IconToUse = getIconToUse(componentState, 'delivery');

  return (
    <GridContainer>
      <IconToUse className="mx-auto" />
      <Header>Delivery {deliveryDate}</Header>
      <Text>
        {daysToAvailability
          ? `Delivered to you within ${daysToAvailability} day${
              daysToAvailability > 1 ? 's' : ''
            }`
          : ''}
      </Text>
      <Clickable
        data-analytics-id="Earliest Delivery open Geolocation Modal"
        onClick={() => {
          setGeolocationModalOpen(true);
        }}
        element={Link}
      >
        {city}, {state}
      </Clickable>
    </GridContainer>
  );
};

export default DeliveryBox;
